import { type Languages, languages } from '@avanta/shared/constants/common';
import { Info, Mail } from 'lucide-react';

interface ProfileSummaryProps {
  userName: string;
  email?: string;
  enterpriseCode?: string;
  languageValue: Languages;
  tCommon: (key: string) => string;
}

export const ProfileSummary = ({
  userName,
  email,
  enterpriseCode,
  languageValue,
  tCommon,
}: ProfileSummaryProps): React.ReactElement => {
  const languageMeta = languages[languageValue] ?? languages.es;
  const languageLabel = tCommon(languageMeta.label);
  const languageDisplayLabel = `${languageLabel} (${languageMeta.shortLabel})`;

  return (
    <div className="ml-8 min-w-0 flex-1">
      <h2 className="text-denim-800 text-xl leading-6 font-medium">{userName}</h2>
      <div className="mt-4 flex items-start">
        <div className="min-w-0 w-full max-w-sm space-y-3">
          <div className="flex min-w-0 items-center">
            <Mail className="text-teal-600 size-4 shrink-0" aria-hidden />
            <span className="text-denim-800 ml-2 truncate text-sm leading-4.5 font-normal">
              {email}
            </span>
          </div>
          {enterpriseCode ? (
            <div className="flex min-w-0 items-center">
              <Info className="text-teal-600 size-4 shrink-0" aria-hidden />
              <span className="text-denim-800 ml-2 truncate text-sm leading-4.5 font-normal">
                {enterpriseCode}
              </span>
            </div>
          ) : null}
        </div>
        <div className="ml-4 flex items-center">
          <img
            src={languageMeta.image}
            alt={languageLabel}
            className="size-4 shrink-0 rounded-full object-cover"
          />
          <span className="text-denim-800 ml-2 text-sm leading-4.5 font-normal">
            {languageDisplayLabel}
          </span>
        </div>
      </div>
    </div>
  );
};
